import React, { useState } from "react";

import {
  WHAT_TO_EXPECT_ENGLISH,
  WHAT_TO_EXPECT_FRENCH,
} from "./utils/constants";

// Images/Icons
import BecomePartner from "assets/breakfast-event/png-jpg/become-partner-2.png";
import BackgroundImage from "assets/breakfast-event/what-to-expect/what-to-expect-bg.png";
import PartnerImage from "assets/breakfast-event/what-to-expect/partner-image.png";

// Modal
import PartnerWaitlistModal from "./components/PartnerWaitlistModal";
// Translations
import { useTranslation } from "react-i18next";

const Sponsors = () => {
  // Translations
  const { t } = useTranslation("event");
  const language = localStorage.getItem("selectedLanguage");

  // Hook state
  const [isOpen, setIsOpen] = useState(false);

  const WHAT_TO_EXPECT = language?.includes("fr")
    ? WHAT_TO_EXPECT_FRENCH
    : WHAT_TO_EXPECT_ENGLISH;

  return (
    <div id="sponsors" className=" scroll-mt-[90px] font-euclid ">
      <div className="bg-[#141B3D] h-full md:h-[580px] pt-[4rem] pb-[3rem] flex justify-center items-center">
        <div className="w-[92%] flex justify-center items-center flex-col text-white gap-[3rem]">
          <div className="flex items-center flex-col gap-5">
            <div className="bg-[#FFC87F33] bg-opacity-20 rounded-full px-3 py-1 w-fit">
              <p className="text-base font-medium text-center font-euclidMedium">
                {t("sponsors.tag")}
              </p>
            </div>
            <h1 className="text-3xl md:text-[48px]  font-euclidSemibold text-center">
              {t("sponsors.title")}
            </h1>
            <p className="text-base md:text-lg  font-euclidRegular text-center">
              {t("sponsors.description")}
            </p>
          </div>
          <img
            src={PartnerImage}
            alt="PartnerImage"
            className="md:w-[1156px] md:h-[154px]"
          />
          <button
            className="border border-none outline-none"
            onClick={() => setIsOpen(true)}
          >
            <img
              src={BecomePartner}
              alt="BecomePartner"
              className="!mb-0 w-[200px]"
            />
          </button>
        </div>
      </div>
      <div className="bg-[#FFF4E3] h-full md:h-[789px] flex justify-center items-center flex-col gap-5 py-10 md:py-0">
        <div className=" flex justify-center items-center flex-col text-[#475569] gap-1">
          <div className="bg-[#BDF8D64D] bg-opacity-20 rounded-full px-3 py-1 w-fit">
            <p className="text-base font-euclidMedium text-center">
              {" "}
              {t("sponsors.pillarTag")}
            </p>
          </div>
        </div>
        <h1 className="text-3xl md:text-[48px] text-[#334155] font-euclidSemibold text-center">
          {t("sponsors.pillarTitle")}
        </h1>
        <div className="w-full relative mt-[1rem] md:my-[4rem]">
          <div className="overflow-x-auto scroll-smooth no-scrollbar overflow-y-hidden">
            <div className="flex gap-5 pl-[3.5rem]">
              {WHAT_TO_EXPECT.map((option, index) => (
                <div
                  key={index}
                  className="group shrink-0 w-[300px] h-[350px] md:w-[354px] md:h-[401px] rounded-lg relative bg-cover bg-center"
                  style={{ backgroundImage: `url(${BackgroundImage})` }}
                >
                  <img
                    src={option.image}
                    alt={`Topic ${index + 1}`}
                    className="w-[300px] h-[140px] md:w-[347px] md:h-[166px] rounded-lg mx-auto"
                  />

                  <div className="flex justify-center items-center flex-col gap-2 px-4">
                    <img
                      src={option.topic}
                      alt={`Topic ${index + 1}`}
                      className="rounded-lg mx-auto"
                    />
                    <h4 className="text-[#334155] text-[24px] font-euclidSemibold text-center">
                      {option.title}
                    </h4>
                    <p className="text-[#475569] text-lg font-euclidMedium text-left">
                      {option.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <PartnerWaitlistModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default Sponsors;
